import SocietiesCarousel from "@/components/societiesCarousel/societiesCarousel.vue"
import SocietiesCarouselMobile from "@/components/societiesCarouselMobile/societiesCarouselMobile.vue"
import VideoCarousel from "@/components/videoCarousel/videoCarousel.vue"
import VideoCarouselMobile from "@/components/videoCarouselMobile/videoCarouselMobile.vue"
import Map from "@/components/map/map.vue"
import CaptureButton from "@/components/landing/captureButton/captureButton.vue"
import installPwa from "@/components/installPwa/installPwa.vue"
import createNoWrapSpecialWordsMixin from "@/mixins/createNoWrapSpecialWordsMixin"
import requestMixin from "@/mixins/requestMixin";
import userAction from "@/mixins/userAction";
import Cookies from "js-cookie";

export default {
    components: {
        SocietiesCarousel, SocietiesCarouselMobile, VideoCarousel, VideoCarouselMobile, Map, CaptureButton, installPwa
    },

    mixins: [
        createNoWrapSpecialWordsMixin, requestMixin, userAction,
    ],

    computed: {
        anchorCardStore() {
            return this.$store.state.anchorCard
        }
    },

    watch: {
        userIsAuthorized() {
            this.isAuthorized = this.userIsAuthorized
        },
        anchorCardStore() {
            this.anchorCard = this.anchorCardStore
            this.scrollToItem()
        }
    },

    data() {
        return {
            anchorCard: true,

            societies: [
                [
                    {
                        title: "К ГТО будь готов",
                        link: "/communitiesPage",
                        src: "🏋️‍♂️",
                        type: 'emoji',
                    },
                    {
                        title: "Прыжки на скакалках",
                        link: "/communitiesPage",
                        src: "mother-and-kid-ice-skating_1.png",
                        type: 'img',
                    },
                    {
                        title: "Катание на роликах",
                        link: "/communitiesPage",
                        src: "seniors-trekking-in-a-forest_3.png",
                        type: 'img',
                    },
                    {
                        title: "Уличная физическая подготовка",
                        link: "/communitiesPage",
                        src: "🤸‍♂️",
                        type: 'emoji',
                    },
                    {
                        title: "Улицы студенческого спорта",
                        link: "/communitiesPage",
                        src: "",
                        type: 'emoji',
                        specialClass: "lobachevsky",
                    },
                ],
                [
                    {
                        title: "К ГТО будь готов",
                        link: "/communitiesPage",
                        src: "🏋️‍♂️",
                        type: 'emoji',
                    },
                    {
                        title: "Прыжки на скакалках",
                        link: "/communitiesPage",
                        src: "mother-and-kid-ice-skating_1.png",
                        type: 'img',
                    },
                    {
                        title: "Катание на роликах",
                        link: "/communitiesPage",
                        src: "seniors-trekking-in-a-forest_3.png",
                        type: 'img',
                    },
                    {
                        title: "Уличная физическая подготовка",
                        link: "/communitiesPage",
                        src: "🤸‍♂️",
                        type: 'emoji',
                    },
                ],
            ],

            linksList: [
                "https://res.cloudinary.com/demo/video/upload/q_auto,f_auto/dog.mp4",
                "https://res.cloudinary.com/demo/video/upload/q_auto,f_auto/dog.mp4",
                "https://res.cloudinary.com/demo/video/upload/q_auto,f_auto/dog.mp4",
                "https://res.cloudinary.com/demo/video/upload/q_auto,f_auto/dog.mp4",
                "https://res.cloudinary.com/demo/video/upload/q_auto,f_auto/dog.mp4",
                "https://res.cloudinary.com/demo/video/upload/q_auto,f_auto/dog.mp4",
            ],

            timeout: {},
        }
    },

    methods: {
        scrollToItem() {
            if (this.anchorCard) {
                setTimeout(() => {
                    this.timeout = this.$refs.map.scrollIntoView({
                        behavior: 'smooth',
                    });
                }, 100)
                this.$store.commit("setAnchorCard", false);
            }
        },
    },
    mounted() {
        this.$store.commit("setAnchorCard", false);
    },
    created() {
        if (this.$route.query.code) {
                const requestConf = {
                    method: "get",
                    url: `/auth/nino-id/${this.$route.query.code}`,
                    checkToken: false,
                };
        
                this.axiosRequest(requestConf).then(res => {
                    Cookies.set("Auth", res.data);
                    this.$store.commit("setUserToken", res.data);
                    this.$store.commit("setUserRefreshToken", res.data);
                    this.getUser();
                    this.$router.replace('/');
                })
                .catch(err => {
                    this.$router.replace('/auth');
                    console.log(err);
                })
        }
    },
    beforeUnmount() {
        clearTimeout(this.timeout);
    }
}
